import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  stagger?: boolean;
  staggerDelay?: number;
}

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  className = '',
  stagger = false,
  staggerDelay = 0.05
}) => {
  const shouldReduceMotion = useReducedMotion();

  const pageVariants = shouldReduceMotion
    ? {
        initial: { opacity: 1 },
        animate: { opacity: 1 },
        exit: { opacity: 1 }
      }
    : {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -20 }
      };

  const transition = {
    duration: 0.3,
    ease: 'easeOut'
  };

  const containerVariants = stagger && !shouldReduceMotion
    ? {
        animate: {
          transition: {
            staggerChildren: staggerDelay
          }
        }
      }
    : undefined;

  return (
    <motion.div
      className={className}
      variants={stagger ? containerVariants : pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={!stagger ? transition : undefined}
    >
      {children}
    </motion.div>
  );
};

export const PageTransitionItem: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = ''
}) => {
  const shouldReduceMotion = useReducedMotion();

  const itemVariants = shouldReduceMotion
    ? undefined
    : {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 }
      };

  return (
    <motion.div
      className={className}
      variants={itemVariants}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};
